var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    key: "landing",
    staticClass: "page__landing"
  }, [_c('section', {
    staticClass: "overflow-hidden",
    attrs: {
      "id": "home"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col d-flex justify-content-center"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require('@/assets/images/landing/charity.png'),
      "alt": _vm.$t('home.welcomeMsg')
    }
  })])]), _c('div', {
    staticClass: "row align-items-center pt-5"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {}, [_c('h1', {
    staticClass: "mb-3",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.welcomeMsg'))
    }
  }), _c('p', {
    staticClass: "text-muted mb-3",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.leading'))
    }
  }), _c('h5', {
    staticClass: "text-secondary mb-4",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.shortDesc'))
    }
  })])])]), _c('div', {
    staticClass: "row pt-5"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm.publicPackages ? _c('h5', {
    staticClass: "page__landing__research-heading"
  }, [_vm._v(" Trenutno aktivne raziskave ")]) : _c('h5', {
    staticClass: "mb-2"
  }, [_c('font-awesome-icon', {
    staticClass: "mr-2",
    attrs: {
      "icon": "info-circle"
    }
  }), _vm._v(" Trenutno žal ni aktivnih raziskav. ")], 1)])]), _vm.publicPackages ? _c('div', {
    staticClass: "row pb-5"
  }, [_c('hr'), _c('div', {
    staticClass: "col page__landing__research"
  }, _vm._l(_vm.publicPackages, function (pkg) {
    return _c('div', {
      key: pkg.id,
      staticClass: "page__landing__research-item"
    }, [_c('div', {
      staticClass: "page__landing__research-item__img-wrapper"
    }, [_c('img', {
      staticClass: "img-fluid",
      class: {
        'object-fit-contain': !(pkg !== null && pkg !== void 0 && pkg.form_img)
      },
      attrs: {
        "src": pkg !== null && pkg !== void 0 && pkg.intro_img ? _vm.helperImgPath(pkg.id, pkg === null || pkg === void 0 ? void 0 : pkg.intro_img) : require('@/assets/logo/logo.png'),
        "alt": pkg.title
      }
    })]), _c('b-link', {
      staticClass: "stretched-link",
      attrs: {
        "to": {
          name: 'Package',
          params: {
            packageSlug: pkg.slug
          }
        }
      }
    }, [_c('p', [_vm._v(" " + _vm._s(pkg.title) + " ")]), _c('font-awesome-icon', {
      staticClass: "text-primary",
      attrs: {
        "align": "bottom",
        "icon": "arrow-right"
      }
    })], 1)], 1);
  }), 0)]) : _vm._e(), _vm._m(0)])]), _vm.showToTop ? _c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: '#topnav',
      expression: "'#topnav'"
    }],
    staticClass: "btn btn-icon btn-soft-primary back-to-top d-block",
    attrs: {
      "href": "#"
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "arrow-up"
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row my-5"
  }, [_c('div', {
    staticClass: "col-auto"
  }, [_c('div', {
    staticClass: "bg-primary text-light rounded p-5"
  }, [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v(" Želite biti obveščeni o novih aktivnih raziskavah? ")]), _c('form', {
    staticClass: "validate",
    attrs: {
      "action": "https://brevisvelox.us5.list-manage.com/subscribe/post?u=baf2e92589d5e24d9115308f2&id=a5054992f7",
      "method": "post",
      "id": "mc-embedded-subscribe-form",
      "name": "mc-embedded-subscribe-form",
      "target": "_blank",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-md-row gap-1"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "value": "",
      "name": "EMAIL",
      "id": "mce-EMAIL",
      "placeholder": "Vaš email naslov ",
      "required": ""
    }
  }), _c('div', {
    staticClass: "input-group-append"
  }, [_c('input', {
    staticClass: "btn btn-sm btn-light rounded-right",
    attrs: {
      "type": "submit",
      "value": "Prijavite se na obvestila",
      "name": "subscribe",
      "id": "mc-embedded-subscribe"
    }
  })]), _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "-5000px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "b_baf2e92589d5e24d9115308f2_a5054992f7",
      "tabindex": "-1",
      "value": ""
    }
  })])])])])])]);
}]

export { render, staticRenderFns }